class QuickAddButton extends ModalOpener {
    constructor() {
        super();
        this.productHandle = this.getAttribute('data-handle');
        this.submitType = this.getAttribute('data-submit');
        this.modalContent = this.modal.querySelector('.base-modal__content');
        this.addEventListener('click', this.openDrawer.bind(this));
    }

    openDrawer(e) {
        e.preventDefault();
        e.stopPropagation();
        
        if (this.submitType == 'show-options') {
            this.classList.add('modal-is-open');
            
            var link = '/products/' + this.productHandle;
            fetch(link)
                .then(res => res.text())
                .then(html => {
                    var parser = new DOMParser();
                    
                    var productElement = parser.parseFromString(html, "text/html");
                    if (productElement == null) {
                        return 0;
                    }
                    var productContent = productElement.querySelector('.shopify-section.product-section');
                    if (productContent.querySelector('.sticky-addtocart-wrapper')) productContent.querySelector('.sticky-addtocart-wrapper').remove();

                    HTMLUpdateUtility.setInnerHTML(this.modalContent, productContent.outerHTML);

                    if (typeof loadingImages === 'function') {
                        loadingImages(this.modalContent);
                    }

                    if (window.Shopify && Shopify.PaymentButton) {
                        Shopify.PaymentButton.init();
                    }
                    if (window.ProductModel) window.ProductModel.loadShopifyXR();
                    
                    if (this.modal && this.modal.show) {
                        this.modal.show(this.buttonOpener);
                    }

                    const quickOptionElement = document.getElementById('product-quick-add-dialog');
                    if (quickOptionElement) {
                        const variantsPicker = quickOptionElement.querySelectorAll('variant-radios, variant-selects');
                        variantsPicker.forEach(element => {
                            element.setAttribute('data-update-url', 'false');
                        });
                    }

                    this.initQuickAddMediaNav();
                });
        } else {
            const formAddToCart = e.target.closest('.product-card-information').querySelector('.form-add-to-cart');
            if (formAddToCart) formAddToCart.submit();
        }
    }

    initQuickAddMediaNav() {
        const container = this.modalContent.querySelector('.product-image-on-quick-add');
        if (!container) return;

        const items = container.querySelectorAll('.quick-add-media-item');
        const prevBtn = container.querySelector('.quick-add-media-nav__btn--prev');
        const nextBtn = container.querySelector('.quick-add-media-nav__btn--next');

        if (!prevBtn || !nextBtn || items.length <= 1) return;

        const navigate = (direction) => {
            const current = container.querySelector('.quick-add-media-item:not(.hidden)');
            if (!current) return;

            const currentIndex = parseInt(current.dataset.quickAddMediaIndex);
            let nextIndex;

            if (direction === 'next') {
                nextIndex = currentIndex + 1 >= items.length ? 0 : currentIndex + 1;
            } else {
                nextIndex = currentIndex - 1 < 0 ? items.length - 1 : currentIndex - 1;
            }

            window.pauseAllMedia();

            current.classList.add('quick-add-fade-out');
            setTimeout(() => {
                current.classList.add('hidden');
                current.classList.remove('quick-add-fade-out');

                const nextItem = container.querySelector(`[data-quick-add-media-index="${nextIndex}"]`);
                if (nextItem) nextItem.classList.remove('hidden');
            }, 300);
        };

        prevBtn.addEventListener('click', () => navigate('prev'));
        nextBtn.addEventListener('click', () => navigate('next'));

        prevBtn.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                navigate('prev');
            }
        });

        nextBtn.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                navigate('next');
            }
        });
    }
}

if (!customElements.get('quick-add-button')) customElements.define('quick-add-button', QuickAddButton);